module.exports = __webpack_public_path__ + "static/img/radar.7059c60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/thumbnails/projects/radar.png
// module id = Hp2v
// module chunks = 0